module.exports = __webpack_public_path__ + "static/media/ls.c0799ebf.svg";